export const styles = {
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flexSpaceBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  flexLeft: {
    display: "flex",
    // justifyContent: "center",
    alignItems: "center",
  },
  bannerImg: {
    width: "150px",
    height: "150px",
  },
  flexCenterSpcaeBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tabItem: {
    backgroundColor: "#EBF4F5",
    // height: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    elevation: "5",
    padding: "50px",
  },
  educationCard: {
    margin: "10px",
    elevation: "0",
  },
  skillCard: {
    margin: "5px",
    elevation: "0",
  },
  icon: {
    margin: "10px 0",
    marginRight: "10px",
    fontSize: 16,
  },
};
